<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <!-- ---- main card ---- -->        
        <v-card
          elevation="4"
          outlined
          style="width:800px"
        >
          <v-toolbar flat>
            <v-toolbar-title>
              {{ $t('logoff.title') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <h3 class="pt-3">
              {{ $t('logoff.text') }}
            </h3>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              outlined
              color="primary"
              @click="cancel"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="secondary"
              @click="logoff"
            >
            {{ $t('logoff.confirmText') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { msalInstance } from '@/services/AuthService';


export default {  
  name: 'Logoff',
  data() {
      return {
      model: null,
      //view only
      loaded: false
    }
  },
  methods: {
    logoff: function() {
      msalInstance.logoutRedirect();
    },
    cancel: function() {
      this.$router.replace('/');
    }
  }
}
</script>